import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import 'hammerjs';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { CommonModule, DecimalPipe } from '@angular/common';
import { DataHelper } from '@helpers/data.helper';
import { RouteGuardHelper } from '@helpers/route.guard.helper';
import { WebWorkerService } from '@app/modules/workers/web-worker.service';
import { DataService } from '@services/data.service';
import { CashoutNew } from './cashout.new';
import { CashoutNewSlip } from './cashout-new-slip';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgApexchartsModule, SharedModule, UtilsModule],
  declarations: [CashoutNew, CashoutNewSlip],
  exports: [CashoutNew],
  providers: [
    ApiService,
    UiHelper,
    UserHelper,
    LocalizationService,
    SignalrServiceLegacy,
    ScrollDispatcher,
    DataHelper,
    DataService,
    RouteGuardHelper,
    WebWorkerService,
    DecimalPipe,
  ],
})
export class RightAreaModule {}
